import {
  createRootRoute,
  Outlet,
  useMatches,
  useNavigate,
} from "@tanstack/react-router";
import { CreateShiftProvider } from "@/features/shift-calendar/CreateShiftProvider";
import { currentPageForLoginRedirect, isOnLoginPage } from "@/shared/lib/loginRedirect";
import { TanStackRouterDevtools } from "@tanstack/react-router-devtools";
import { useAuthStore } from "@shared/state/authstore";
import { useEffect } from "react";
import { AppLayout } from "@shared/components/layout/AppLayout";


type routeFlags = {
  authorize: boolean;
  requiresAccount?: boolean;
  pathName: string;
};

const RootLayout = () => {
  const refreshToken = useAuthStore((state) => state.refreshToken);
  const navigate = useNavigate();
  const matches = useMatches();

  const currentRouteFlag = matches.at(-1)?.staticData as routeFlags;

  useEffect(() => {
    if (refreshToken === null && currentRouteFlag?.authorize && !isOnLoginPage()) {
      navigate({ to: "/login", search: { redirect: currentPageForLoginRedirect() } });
    }
  }, [refreshToken, currentRouteFlag, navigate]);

  if (!currentRouteFlag?.authorize) {
    return (
      <>
        <Outlet />
        <TanStackRouterDevtools />
      </>
    );
  }
  return (
    <>
      <CreateShiftProvider>
        <AppLayout>
          <Outlet />
        </AppLayout>
      </CreateShiftProvider>
      <TanStackRouterDevtools />
    </>
  );
};

export const Route = createRootRoute({ component: RootLayout });
